module.exports = __webpack_public_path__ + "img/illu-hole-mask.e39764f1.svg";